import React from 'react'

import styles from './MainContent.module.scss'
import cx from 'classnames'
import { useLocation, PANEL } from 'ducks/router'

export const MainContent = ({ children }) => {
  const location = useLocation()

  const modern = location.type === PANEL

  return (
    <main className={cx(styles.main, { [styles.modern]: Boolean(modern) })}>
      {children}
    </main>
  )
}
